import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlService } from '@core/services/url/url.service';

import { AccessProject } from '@app/models/access';

@Injectable({
  providedIn: 'root',
})
export class TransferService {
  constructor(private urlSrv: UrlService, private http: HttpClient) {}



  // /**
  //  * This send a post request for send a share for any type.
  //  * @param data the data for the share requested
  //  * @returns 
  //  */

  sendShareRequest = (data: any): Observable<any> => {
    const url = this.urlSrv.build('/share'); 
    // Set your custom headers if needed
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // Add more headers if necessary
    });

    return this.http.post(url, data)
  }

  public loadVersion = (versionId: number) =>
    this.http.get(this.urlSrv.build('/versions/' + versionId));

  public loadVersionFiles = (versionId: number) => 
    this.http.get(this.urlSrv.build('/versions/' + versionId + '/files'));

  // load the project 
  public loadProject = (projectId: number) => {
    return this.http.get(this.urlSrv.build('/requests/' + projectId),
      { observe: 'response' })
  };

  public loadProjectPermissions = (projectId: number) => {
    return this.http.get(this.urlSrv.build('/requests/' + projectId + "/permissions"))
  };

  public loadFile = (fileId: number) => this.http.get(this.urlSrv.build('/files/'+fileId)+"?f=json");
  
}